module.exports = __webpack_public_path__ + "static/fabric-table-expandable-open-acc0a8ddd18c4416b8e3ae1f5e4806c6.png";